module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "addPayment",
    attrs: {
      "hide-footer": "",
      "title": "Dodaj wpłatę"
    }
  }, [(_vm.paymentLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.selectedInvoice && !_vm.paymentLoading) ? _c('form-payment', {
    ref: "addPaymentForm",
    attrs: {
      "currencyName": _vm.invoiceCurrency,
      "handleSubmit": _vm.handlePayment,
      "values": _vm.paymentData,
      "errors": _vm.paymentViolations
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.paymentLoading) ? _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.hideAddPaymentModal
    }
  }, [_c('span', [_vm._v("Anuluj")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1)], 1), _vm._v(" "), _c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "default",
      "block": ""
    },
    on: {
      "click": _vm.sendPaymentForm
    }
  }, [_c('span', [_vm._v("Zapisz")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "tick"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('b-modal', {
    ref: "paymentList",
    attrs: {
      "hide-footer": ""
    }
  }, [(_vm.paymentListLoading || _vm.paymentDeleteLoading || _vm.deductionListLoading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.paymentListLoading && !_vm.paymentDeleteLoading && !_vm.deductionListLoading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h3', [_vm._v("Lista wpłat")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Kwota")]), _vm._v(" "), _c('th', [_vm._v("Data wpłaty")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.paymentListItems), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(_vm._f("date")(item.paymentDate)))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-icon btn-icon--warning",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.deletePayment(item)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "minus"
      }
    })], 1)])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.paymentListLoading && !_vm.paymentDeleteLoading && !_vm.deductionListLoading && _vm.deductionListItems.length > 0) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('h3', [_vm._v("Lista potrąceń")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Kwota")]), _vm._v(" "), _c('th', [_vm._v("Data potrącenia")]), _vm._v(" "), _c('th', [_vm._v("Opis")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.deductionListItems), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.amount))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(_vm._f("date")(item.deductionDate)))]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v(_vm._s(item.description))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.paymentListLoading && !_vm.paymentDeleteLoading) ? _c('b-row', [_c('b-col', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "block": ""
    },
    on: {
      "click": _vm.hidePaymentList
    }
  }, [_c('span', [_vm._v("Zamknij")]), _vm._v(" "), _c('svg-icon', {
    attrs: {
      "name": "back"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.createdPaymentMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Płatność w kwocie " + _vm._s(_vm.createdPaymentMessage) + " została dodana")]) : _vm._e(), _vm._v(" "), (_vm.deletePaymentMessage) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v("Płatność w kwocie " + _vm._s(_vm.deletePaymentMessage) + " została usunięta")]) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item['number']) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("date")(item['createDate'])) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("date")(item['paymentDate'])) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item['debtorData']['name']) + ","), _c('br'), _vm._v("NIP: " + _vm._s(item['debtorData']['nip']) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item['amount']) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(item['leftToPaid']) + "\n                ")]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [(item['paid']) ? _c('span', {
      staticClass: "element_status closed"
    }, [_vm._v("Zapłacona")]) : _vm._e(), _vm._v(" "), (!item['paid'] && !item['deducted']) ? _c('span', {
      staticClass: "element_status open"
    }, [_vm._v("Niezapłacona")]) : _vm._e(), _vm._v(" "), (item['deducted']) ? _c('span', {
      staticClass: "element_status deducted"
    }, [_vm._v("Potrącona")]) : _vm._e(), _vm._v(" "), (item['returned']) ? _c('span', {
      staticClass: "element_status returned"
    }, [_vm._v("Zwrócona")]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "td-no_link"
    }, [_vm._v("\n                    " + _vm._s(_vm._f("translate")(item['cessionAvailable'])) + "\n                ")]), _vm._v(" "), _c('td', [_c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon btn-icon--success",
      attrs: {
        "href": "#",
        "title": "Dodaj wpłatę"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.addPayment(item)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "confirm"
      }
    })], 1), _vm._v(" "), _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon btn-icon--cancel",
      attrs: {
        "href": "#",
        "title": "Lista wpłat"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.showPaymentList(item)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "money"
      }
    })], 1), _vm._v(" "), (_vm.showEditButton) ? _c('br') : _vm._e(), _vm._v(" "), (_vm.showEditButton) ? _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "href": "#",
        "title": "Edytuj"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.editAction(item)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1) : _vm._e(), _vm._v(" "), (_vm.showEditButton) ? _c('a', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon btn-icon--warning",
      attrs: {
        "href": "#",
        "title": "Usuń"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.del(item)
        }
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "minus"
      }
    })], 1) : _vm._e()])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Numer")]), _vm._v(" "), _c('th', [_vm._v("Data wystawienia")]), _vm._v(" "), _c('th', [_vm._v("Termin płatności")]), _vm._v(" "), _c('th', [_vm._v("Dłużnik")]), _vm._v(" "), _c('th', [_vm._v("Kwota")]), _vm._v(" "), _c('th', [_vm._v("Do zapłaty")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Cesja")]), _vm._v(" "), _c('th')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4bd2998","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/agreement/invoiceList.vue
// module id = 856
// module chunks = 0